export default [
  {
    name: 'envMapTexture',
    type: 'cubeTexture',
    path: [
      'textures/environmentMap/px.jpg',
      'textures/environmentMap/nx.jpg',
      'textures/environmentMap/py.jpg',
      'textures/environmentMap/ny.jpg',
      'textures/environmentMap/pz.jpg',
      'textures/environmentMap/nz.jpg',
    ],
  },
  {
    name: 'grassColorTexture',
    type: 'texture',
    path: 'textures/dirt/color.jpg',
  },
  {
    name: 'grassNormalTexture',
    type: 'texture',
    path: 'textures/dirt/normal.jpg',
  },
  {
    name: 'HellFest',
    type: 'gltfModel',
    path: 'models/Hell/glTF/HF.glb',
  },
  {
    name: 'doorTexture',
    type: 'texture',
    path: 'models/Hell/glTF/door.jpg',
  },
  {
    name: 'structureTexture',
    type: 'texture',
    path: 'models/Hell/glTF/structure.jpg',
  },
  {
    name: 'detailTexture',
    type: 'texture',
    path: 'models/Hell/glTF/detail.jpg',
  },
  {
    name: 'statueTexture',
    type: 'texture',
    path: 'models/Hell/glTF/statue.png',
  },
  {
    name: 'paintingTexture',
    type: 'texture',
    path: 'models/Hell/glTF/painting.png',
  },
]
